/*
@PRODUCT_FEATURE: TU 1.0
*/
import View from './View';

export { default as View, getSettingsDeviceManagementStyles } from './View';

export default View;
